/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SCIMGroupRead = {
  readonly id?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  readonly scim_group_id?: string;
  external_id?: string | null;
  display_name: string;
  role_mapped: SCIMGroupRead.role_mapped;
  display_name_normalized: string;
  scim_configuration: number;
};
export namespace SCIMGroupRead {
  export enum role_mapped {
    '_0' = 0,
    '_2' = 2,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
  }
}

